module.exports = __webpack_public_path__ + "img/american-logo.94ceaa3f.svg";